if (!window.Eurus.loadedScript.includes('pagination.js')) {
  window.Eurus.loadedScript.push('pagination.js');

  requestAnimationFrame(() => {
    document.addEventListener("alpine:init", () => {
      Alpine.data("xPagination", (sectionId) => ({
        loading: false,
        loadData(url) {
          if (this.loading || !url) return;
          this.loading = true
          fetch(url)
          .then(response => response.text())
          .then(response => {
            const parser = new DOMParser();
            const html = parser.parseFromString(response,'text/html');
            const productGrid = html.getElementById('items-grid');
            const newProducts = productGrid ? Array.from(productGrid.getElementsByClassName('grid-item')) : [];
            let productsOnPage = document.getElementById("items-grid");
            let blogGrid = document.getElementById("blog-grid");
            if (blogGrid) { productsOnPage = blogGrid }
            if (!productsOnPage) return;

            const existingProductIds = new Set();
            productsOnPage.querySelectorAll('[data-product-id]').forEach(el => {
              if (el.dataset.productId) existingProductIds.add(el.dataset.productId);
            });

            const uniqueProducts = newProducts.filter(item => {
              const card = item.querySelector('[data-product-id]');
              const prodId = card ? card.dataset.productId : null;
              if (prodId && existingProductIds.has(prodId)) {
                return false;
              }
              if (prodId) existingProductIds.add(prodId);
              return true;
            });

            if (uniqueProducts.length === 0) {
              this._renderButton(html);
              return;
            }

            for (let i = 0; i < uniqueProducts.length; i++) {
              setTimeout(() => {
                productsOnPage.insertAdjacentHTML('beforeend', uniqueProducts[i].outerHTML || uniqueProducts[i].innerHTML);
                if (i === uniqueProducts.length - 1) {
                  this._renderButton(html);
                }
              }, i*300);
            }
          })
          .catch(e => {
            console.error(e);
          })
          .finally(() => {
            this.loading = false;
          })
        } ,
        _renderButton(html) {
          const destination = document.getElementById('btn-pagination-' + sectionId);
          const source = html.getElementById('btn-pagination-' + sectionId);
          if (destination && source) {
            destination.innerHTML = source.innerHTML;
            if (source.hasAttribute('data-loaded-count')) {
              destination.setAttribute('data-loaded-count', source.getAttribute('data-loaded-count'));
            }
            if (source.hasAttribute('data-total')) {
              destination.setAttribute('data-total', source.getAttribute('data-total'));
            }
            if (window.Alpine && typeof Alpine.initTree === 'function') {
              Array.from(destination.children).forEach((child) => Alpine.initTree(child));
            }
          }
          this._updateProductCount(html);
        },
        _updateProductCount(html) {
          const source = html.getElementById('btn-pagination-' + sectionId);
          if (!source) return;
          const loaded = source.getAttribute('data-loaded-count');
          if (loaded == null) return;
          const total = source.getAttribute('data-total');
          document.querySelectorAll('[data-product-count]').forEach((el) => {
            const template = el.getAttribute('data-count-template');
            if (!template) return;
            const from = el.getAttribute('data-count-from') || '1';
            const count = total || el.getAttribute('data-count-total') || '';
            el.textContent = template
              .replaceAll('__from__', from)
              .replaceAll('__to__', loaded)
              .replaceAll('__count__', count);
          });
        }
      }));
    });
  });
}